import { ReactNode } from 'react';
import * as yup from 'yup';

import { InputProps } from '../design-system';

export enum AccountFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Password = 'password',
  CurrentPassword = 'currentPassword',
  NewPassword = 'newPassword',
  ConfirmNewPassword = 'confirmNewPassword',
  StreetAddress = 'streetAddress',
  City = 'city',
  State = 'state',
  Zipcode = 'zipCode',
  Phone = 'phone',
  CompanyName = 'companyName',
  AgentSelfAttestation = 'agentSelfAttestation',
}

export interface AccountFieldConfig {
  label: string;
  description?: ReactNode;
  field: string;
  inputProps?: Omit<InputProps, 'dataHcName' | 'value' | 'onChange'>;
  validator: yup.AnySchema;
}

export interface SelfServiceRegisterFormFields {
  [AccountFields.FirstName]: string;
  [AccountFields.LastName]: string;
  [AccountFields.CompanyName]?: string | null;
  [AccountFields.Email]: string;
  [AccountFields.Password]: string;
  [AccountFields.AgentSelfAttestation]?: boolean;
  coupon_code: string | null;
}

export interface SignUpFormFields {
  [AccountFields.FirstName]: string;
  [AccountFields.LastName]: string;
  [AccountFields.Email]: string;
  [AccountFields.Password]: string;
}

export interface ForgotPasswordFormFields {
  [AccountFields.Email]: string;
}

export interface ResetPasswordFormFields {
  [AccountFields.NewPassword]: string;
  [AccountFields.ConfirmNewPassword]: string;
}

export interface ResetPasswordPayload {
  nonce?: string;
  token?: string;
  [AccountFields.NewPassword]: string;
}
